/**
 * useKisiFoto.js — bir kişinin vesikalığını (GET /personnel/{id}/fotograf, kimlik doğrulamalı) blob olarak okur
 * (backlog #350, #352; backend #351).
 *
 * Uç <img src> ile çağrılamaz (Authorization başlığı ister), bu yüzden blob'a çevrilip object URL verilir.
 * `fotografVar` bayrağı (satırda / kart-karari'nde gelir) false iken istek HİÇ atılmaz: eski PHP dosyalarının çoğu 404.
 * `surum` değişirse yeniden okunur (fotoğraf yüklendikten sonra satırın `logo` alanı ya da bir sayaç verilir).
 * Okunamayan fotoğraf null döner; çağıran yer tutucuyu gösterir.
 *
 * @returns {string|null} object URL (bileşen kalkınca/değişince otomatik serbest bırakılır)
 */
import { useEffect, useState } from "react";
import { fetchKisiFotograf } from "../../services/personelRosterService";

export default function useKisiFoto(personId, fotografVar, surum = 0) {
  const [foto, setFoto] = useState(null); // { id, url }

  useEffect(() => {
    if (!personId || !fotografVar) return undefined;
    let iptal = false;
    let url = null;
    async function oku() {
      try {
        url = await fetchKisiFotograf(personId);
        if (iptal) {
          URL.revokeObjectURL(url);
          url = null;
          return;
        }
        setFoto({ id: personId, url });
      } catch {
        if (!iptal) setFoto(null);
      }
    }
    oku();
    return () => {
      iptal = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [personId, fotografVar, surum]);

  return fotografVar && foto && foto.id === personId ? foto.url : null;
}
